import { init as initMainCollectionProducts } from "../sections/main-collection-products";
import { init as initSortBy } from "../sections/sort-by";
import { init as initVideoSection } from "../sections/video";

export function init() {
  const productsSection = document.querySelector(
    ".shopify-section.main-collection-products"
  );
  if (productsSection instanceof HTMLElement) {
    initMainCollectionProducts(productsSection);
  }
  const controlsSection = document.querySelector(".shopify-section.sort-by");
  if (controlsSection instanceof HTMLElement) {
    initSortBy(controlsSection);
  }

  /* Video (self-hosted) with controls */
  const pageVideoSections = Array.from(
    document.querySelectorAll(".shopify-section.video")
  );
  for (let section of pageVideoSections) {
    if (section instanceof HTMLElement) {
      initVideoSection(section);
    }
  }
}
